const FISCAL_TYPES = {
  NAO_HOMOLOGADO: 0,
  NFCE: 1,
  SAT: 2,
};

export default FISCAL_TYPES;